import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateSettingsResponseTypes } from "../common/response.common";
import { asRemoveHook, asUpdateHook, get, post } from "./common";

export const associateSettings = {
    obtain() {
        return get<AssociateSettingsResponseTypes.Obtain>(`/associate-settings/obtain`);
    },
    formHooks: {
        update(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateSettings.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-settings/update`, data),
                    isLoading,
                );
            };
        },
        remove(isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateSettings.Remove.Input) => {
                return await asRemoveHook(
                    post<typeof data>(`/associate-settings/remove`, data),
                    isLoading,
                );
            };
        },
    },
};
